<template>
  <div class="header">
    <div class="l-head">
      <h1 class="l-logo-img">
        <!-- <img class="l-logo" src="../../../static/logo.png" alt="logo" /> -->
        <img
          style="width: 40px; margin-top: -4px; cursor: pointer"
          src="../../../static/logo-2.png"
          alt="logo"
        />
      </h1>
      <div class="l-head-list">
        <div class="l-h-l-view">
          <ul class="l-h-l-ul">
            <li
              class="l-h-l-li"
              :class="$route.name === 'Home' ? 'l-h-l-li-active' : ''"
              @click="navgoTo(`/home`)"
            >
              播聘集团
            </li>
            <li
              class="l-h-l-li"
              :class="$route.name === 'DSDownload' ? 'l-h-l-li-active' : ''"
              @click="navgoTo(`/ds/download`)"
            >
              裁员优化
            </li>
            <li class="l-h-l-li" @click="navgoTo(`/pa/download`)">
              合约招聘
              <div class="virtualMenu">
                <div
                  class="virtualMenuItem"
                  @click.stop="navgoTo(`/pa/download`)"
                >
                  软件下载
                </div>
                <div
                  class="virtualMenuItem"
                  @click.stop="navgoTo(`/enterprise-home`)"
                >
                  合约介绍
                </div>
                <div
                  class="virtualMenuItem"
                  @click.stop="navgoTo(`/enterprise-server`)"
                >
                  业务类型
                </div>
                <div
                  class="virtualMenuItem"
                  @click.stop="navgoTo(`/enterprise-case`)"
                >
                  客户案例
                </div>
              </div>
            </li>
            <li
              :class="$route.name === 'VIPDownload' ? 'l-h-l-li-active' : ''"
              class="l-h-l-li"
              @click="navgoTo(`/vip/download`)"
            >
              自助招聘
            </li>
            <li
              :class="$route.name === 'YCDownload' ? 'l-h-l-li-active' : ''"
              class="l-h-l-li"
              @click="navgoTo(`/yc/download`)"
            >
              预存招聘
            </li>

            <li
              :class="$route.name === 'JobEmployment' ? 'l-h-l-li-active' : ''"
              class="l-h-l-li"
              @click="navgoTo(`/job/job`)"
            >
              求职就业
            </li>
            <li class="l-h-l-li" @click="navgoTo(`/bp/invest`)">
              消费贸易投资理财
            </li>
            <li class="l-h-l-li" @click="navgoTo(`/bp/aiGlass`)">AI科技</li>
            <li
              class="l-h-l-li"
              :class="$route.name === 'CompanyFinancing' ? 'l-h-l-li-active' : ''"
              @click="navgoTo(`/company-financing/company-financing`)">企业投融资</li>
            <li
              class="l-h-l-li"
              :class="$route.name === 'CompanyMiddleAndSmall' ? 'l-h-l-li-active' : ''"
              @click="navgoTo(`/company-middle-and-small/company-middle-and-small`)">中小微企业金融服务</li>
<!--            <li-->
<!--              :class="$route.name === 'YCDownload' ? 'l-h-l-li-active' : ''"-->
<!--              class="l-h-l-li"-->
<!--              @click="navgoTo(`/appDownload`)"-->
<!--            >-->
<!--              APP下载-->
<!--            </li>-->
            <li class="l-h-l-li" @click="navgoTo(`/company-relation`)">
              联系播聘
            </li>
          </ul>
        </div>
        <div
          style="
            position: absolute;
            right: 90px;
            top: 45%;
            transform: translateY(-50%);
          "
        >
          <span style="color: #000; font-size: 16px">中文</span>
          <span style="color: #000; font-size: 16px; margin-left: 10px"
            >其他语言
            <span style="display: inline-block; transform: rotate(180deg)"
              >▲</span
            ></span
          >
          <!-- <button class="l-head-btn1" type="button">我要求职</button>
					<button class="l-head-btn" type="button">我要招聘</button> -->
          <!-- <a href="https://www.abopin.com/ep_manager" class="l-head-btn_1" >注册登录</a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isHome: {
      type: [Boolean],
      default: !0,
    },
  },
  data() {
    return {
      navBar: {
        title: "播聘新闻",
        path: "/show-news",
      },
    };
  },
  created() {
    this.route();
  },
  methods: {
    handleClick() {
      window.open("https://media.abopin.com", "_blank");
    },
    navgoTo(path) {
      this.$nav({ path: path }, this);
    },
    route() {
      let n = this.$route;
    },
  },
  watch: {
    $route(n) {
      this.route();
    },
  },
  mounted() {
    $(".l-h-l-li").hover(
      function () {
        $(this).find(".virtualMenu").css("display", "flex");
      },
      function () {
        $(this).find(".virtualMenu").css("display", "none");
      }
    );
  },
};
</script>

<style scoped="scoped">
@import url("./navbar.css");
</style>



// WEBPACK FOOTER //
// src/components/navbar/navbar.vue